import cookies from 'browser-cookies';
import { getMainDomain } from '@sv-support-sdk/utils/src/helpers/domain';
import { IS_LOCAL } from '../config';

export const domain = IS_LOCAL ? '' : `.${getMainDomain()}`;
export const getCookie = (key: string): string | null => cookies.get(key);

export const setCookie = (key: string, value: string | number, options = {}) =>
  cookies.set(key, value.toString(), { domain, ...options });

export const removeCookie = (key: string): void => {
  setCookie(key, '');
};
